const PendingOverlockUnlockFilterStyle = ({ firstLabel: { paddingBottom: '16px' } });

export default PendingOverlockUnlockFilterStyle;
